import { CircularProgress, Collapse, Typography } from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/styles";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import CurrentCompanyDataFieldsContainer from "../../../../containers/admin/contacts/accordionFields/CurrentCompanyDataFieldsContainer";

const useStyles = makeStyles((theme) => ({
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSection: {
    padding: '16px 22px',
    background: '#fff',
    marginBottom: '15px',
    borderRadius: '3px',
  },
  contentSectionHeaderTitle: {
    fontSize: '17px',
    fontWeight: '600',
    color: '#000',
  },
  contentSectionContent: {

  },
  formGroup: {
    padding: theme.spacing(2, 0)
  },
  addNewRelationshipLink: {
    textTransform: 'capitalize',
    textDecoration: 'none',
    fontWeight: '600',
    cursor: 'pointer',
    marginBottom: '16px',
    display: 'inline-block',
    '&:hover': {
      textDecoration: 'none',
    }
  },
}));

const CurrentCompanyData = (props) => {
  const classes = useStyles();
  const { currentCompanyData, handleTabChange, currentCompanyDataStatus, handleCompanyDataChange, tab } = props;

  return (
    <div className={classes.contentSection}>
      <div className={classes.contentSectionHeader} onClick={(event) => handleTabChange(event, 20)}>
        <Typography variant='h5' className={`${classes.contentSectionHeaderTitle} ${tab === 20 ? classes.tabActive : ''}`}>Current Companies Data</Typography>
        {currentCompanyDataStatus === 'start' ? <CircularProgress /> : ''}
        {tab === 20 ? <ExpandLess /> : <ExpandMore />}
      </div>
      <Collapse in={tab === 20}>
        <div className={classes.contentSectionContent}>
          <div className={classes.formGroup}>
            {currentCompanyData.map((props) => <CurrentCompanyDataFieldsContainer key={props.id} companyData={props} onChange={handleCompanyDataChange} />)}
          </div>
        </div>
      </Collapse>
    </div>
  )
}

export default CurrentCompanyData;